import clsx from 'clsx'
import type { HTMLAttributes, ReactNode } from 'react'

interface PageFullProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

export function PageFull({
  children,
  className,
  style,
  ...rest
}: PageFullProps) {
  return (
    <div
      className={clsx(
        'box-border',
        'relative overflow-y-auto overflow-x-hidden bg-white text-base',
        'max-w-(--max-width) mx-auto',
        'w-[min(var(--visual-viewport-width,100vw),var(--max-width))]',
        'scrollbar-hide',
        'min-h-full',
        className,
      )}
      style={style}
      {...rest}
    >
      {children}
    </div>
  )
}
